var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './Input.scss';
var Input = function (_a) {
    var placeholder = _a.placeholder, _b = _a.type, type = _b === void 0 ? 'Input' : _b, _c = _a.password, password = _c === void 0 ? false : _c, register = _a.register, error = _a.error, disabled = _a.disabled, style = _a.style, _d = _a.inputType, inputType = _d === void 0 ? 'text' : _d, _e = _a.readOnly, readOnly = _e === void 0 ? false : _e, onChange = _a.onChange, // Добавьте это
    value = _a.value;
    return type === 'Input' ? (_jsx("input", __assign({ autoComplete: "off" }, register, error, { disabled: disabled, style: __assign({ color: disabled ? '#898989' : '#000000' }, style), type: password ? 'password' : inputType, placeholder: placeholder, className: "Input ".concat(error ? 'error' : ''), onChange: onChange, readOnly: readOnly, value: value }))) : (_jsx("textarea", __assign({}, register, { className: "TextArea ".concat(error ? 'error' : ''), placeholder: placeholder, onChange: onChange, readOnly: readOnly, value: value })));
};
export default Input;
